import { luscinia } from "./luscinia";

luscinia.translate = async function (valueToTranslate: string) {
    const result = await fetch("/translation/translate", {
        method: "POST",
        body: valueToTranslate,
    });

    return await result.text();
};
